define.alias("shared/components/shared/post/secondary/hashtag-suggestions/item", "preview-grid/components/shared/post/secondary/hashtag-suggestions/item");